import axiosClient from 'api/axiosClient';
import API_MAP from 'constants/api';
import { FONT_SYSTEMS, VMP_THEME } from 'constants/theme';

export const themeService = {
    getThemeSystem: async (config) => {
        const result = await axiosClient.get(API_MAP.WHITE_LABEL.GET_INFO, config);
        const data = result?.data;

        const _data = {
            primary: data?.primary_color_branding || '#CB002B',
            secondary: data?.secondary_color_branding || '#A0616A',
            text: data?.color_font || '#44494d',
            blur: data?.manager_image_opacity ?? 0,
            // legacy configs may still hold a font that is no longer bundled
            font: FONT_SYSTEMS.includes(data?.font) ? data.font : VMP_THEME.font,
            background: data?.manager_image_path || null,
            backgroundImages: data?.manager_background_images || [],
            isDefault: data?.is_default ?? 1,
        };

        return _data;
    },
    updateThemeImageSystem: async (formData, slot) => {
        try {
            const result = await axiosClient.post(
                API_MAP.WHITE_LABEL.UPLOAD_BACKGROUND_IMAGE + `?slot=${slot}`,
                formData,
            );
            return result;
        } catch (error) {
            throw error;
        }
    },
    updateThemeSystem: async (data, slot) => {
        try {
            const result = await axiosClient.post(API_MAP.WHITE_LABEL.UPDATE + `?slot=${slot ? slot : ''}`, data);
            return result;
        } catch (error) {
            throw error;
        }
    },
    remveBackground: async (data) => {
        try {
            const body = {
                remove_background_array: data,
            };
            await axiosClient.post(API_MAP.WHITE_LABEL.REMOVE_BACKGROUND, body);
        } catch (error) {
            throw error;
        }
    },
};
